export default {
	tenantId: "tawuniya_uat",
	appId: "covergo_crm",
	fileSystem: {
		bucketName: "tawuniya--uat"
	}
}
